export function eventKey(event) {
    return `${event.type}-${event.event_id}`;
}
